import { useBoolean } from "@/ui-kit";
import { useAppStore } from "@/store/app/slice";
import { EditUserModal } from "@/pages/Settings/components/EditUserModal";
import { SectionSkeleton, UserOverviewCard } from "@/components/profile-cards";
import { UserLoadingStatus } from "@/types/users";

export const UserOverview = () => {
  const user = useAppStore((s) => s.user);
  const userLoaded = useAppStore((s) => s.userLoaded);

  const {
    value: showEditUserModal,
    setTrue: openEditUserModal,
    setFalse: dismissEditUserModal,
  } = useBoolean(false);

  if (!user) {
    if (userLoaded !== UserLoadingStatus.Loaded) {
      return <SectionSkeleton />;
    }

    return null;
  }

  return (
    <>
      <UserOverviewCard user={user} onEdit={openEditUserModal} />
      {showEditUserModal && <EditUserModal onDismiss={dismissEditUserModal} />}
    </>
  );
};
